<template>
  <form
    @submit="validateForm"
    :id="id"
    :name="name"
    :method="formMethod"
    :action="action"
    :ref="id"
  >
    <input v-if="method.toLowerCase() === 'put'" type="hidden" name="_method" value="PUT" />
    <input type="hidden" name="_token" :value="csrf" />

    <slot />
  </form>
</template>

<script>
export default {
  props: {
    id: { type: String, default: "form-wrapper" },
    name: { type: String, required: false },
    method: { type: String, required: false },
    action: { type: String, required: false },
    skipValidation: { type: Boolean, default: false }
  },
  computed: {
    csrf() {
      return document.head.querySelector('meta[name="csrf-token"]').content;
    },
    formMethod() {
      return this.method.toUpperCase() === "GET"
        ? this.method.toUpperCase()
        : "POST";
    }
  },
  methods: {
    async validateForm(e) {
      if (!this.skipValidation) {
        await this.$validator.validateAll();

        if (this.errors.any()) e.preventDefault();
      }

      this.$emit("submit");
      return true;
    },
    submit() {
      this.$refs[this.id].submit();
    }
  }
};
</script>
